/**
 * 打开新视图
 * 目前适用于卡牛，随手记
 */
import useragent from '@common/useragent'
import { absUrl } from '@common/host'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'
import { compare } from './version'

export default (_url, callBack, isBounce = false) => {
  const url = absUrl(_url)
  // 随手记安卓特性版本10.7.2.5，bounce效果需要添加src参数
  const SUISHOUJI_ANDROID = '10.7.2.5'
  if (useragent.isSuishouji) {
    if (useragent.isAndroid && compare(SUISHOUJI_ANDROID) && isBounce) {
      call(uriSuishouji('requestMarket', {
        url,
        src: 'finance'
      }))
    } else {
      call(uriSuishouji('requestMarket', { url }))
    }
  } else if (useragent.isKaniu) {
    const featureVersion = useragent.isAndroid ? '7.7.7' : '7.7.2'
    call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo) => {
      if (compare(featureVersion, dataInfo.version)) {
        call(`cardniu://app/newWindowOpen?url=${encodeURIComponent(url)}`)
      } else {
        window.location.href = url
      }
    })
  } else if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://app/webview/newWindowOpen', {
      url,
    }, 'onNewView')
    call(uri, 'onNewView', callBack)
  } else {
    window.location.href = url
  }
}
